import { connect } from 'react-redux';
import { breakpoints } from 'styles';
import { EmptyIndicator, Owners } from 'components/common';
import {
  Box,
  BoxTable,
  BoxTableCell,
  BoxTableHeader,
  BoxTableRow
} from 'components/common/box';
import { GroupsSearch } from '.';

const GroupsList = connect((state) => ({
  coursesVisible: !state.serverConfig.hideCoursesFromUI,
  messages: state.messages,
  pageState: state.pageState,
  theme: state.theme,
  user: state.user
}))(
  ({
    coursesVisible,
    messages,
    pageState: { groups, loading },
    theme,
    updateGroups,
    user
  }) => {
    return (
      <div className="groups-list">
        <Box
          headerContent={<GroupsSearch updateGroups={updateGroups} />}
          padding={0}
          loading={loading}
        >
          {groups && groups.length ? (
            <BoxTable>
              <BoxTableHeader hideAtBreakpoint={breakpoints.medium}>
                <BoxTableCell>{messages.commonGroup}</BoxTableCell>
                {coursesVisible && (
                  <BoxTableCell>{messages.commonCourses}</BoxTableCell>
                )}
                <BoxTableCell>{messages.groupsAddedUsers}</BoxTableCell>
                <BoxTableCell>
                  {messages.groupsUserAttributesUsers}
                </BoxTableCell>
                <BoxTableCell>
                  {messages.groupsUserAttributesConditions}
                </BoxTableCell>
              </BoxTableHeader>

              {groups.map((group) => (
                <BoxTableRow
                  key={group.id}
                  {...(user?.roles?.includes('superadmin') ||
                  group.owners.find((owner) => owner.id === user?.id) ||
                  group.admins
                    .find((admin) => admin.id === user?.id)
                    ?.permissions.includes('manage-users')
                    ? {
                        as: `/groups/${group.id}`,
                        href: '/groups/[groupId]'
                      }
                    : group.admins
                        .find((admin) => admin.id === user?.id)
                        ?.permissions.includes('manage-courses') &&
                      coursesVisible
                    ? {
                        as: `/groups/${group.id}/courses`,
                        href: '/groups/[groupId]/courses'
                      }
                    : group.admins
                        .find((admin) => admin.id === user?.id)
                        ?.permissions.includes('view-analytics') &&
                      coursesVisible
                    ? {
                        as: `/groups/${group.id}/follow`,
                        href: '/groups/[groupId]/follow'
                      }
                    : {
                        as: `/groups`,
                        href: '/groups'
                      })}
                >
                  <BoxTableCell
                    cellBreakpoint={breakpoints.medium}
                    label={messages.commonGroup}
                  >
                    <div className="info">
                      <div className="title">{group.title}</div>
                      <div className="owners">
                        <Owners owners={group.owners} />
                      </div>
                    </div>
                  </BoxTableCell>
                  {coursesVisible && (
                    <BoxTableCell
                      cellBreakpoint={breakpoints.medium}
                      label={messages.commonCourses}
                    >
                      {group.numberOfCourses}
                    </BoxTableCell>
                  )}
                  <BoxTableCell
                    cellBreakpoint={breakpoints.medium}
                    label={messages.groupsAddedUsers}
                  >
                    {group.numberOfUsers}
                  </BoxTableCell>
                  <BoxTableCell
                    cellBreakpoint={breakpoints.medium}
                    label={messages.groupsUserAttributesUsers}
                  >
                    {group.numberOfAttributeUsers}
                  </BoxTableCell>
                  <BoxTableCell
                    cellBreakpoint={breakpoints.medium}
                    label={messages.groupsUserAttributesConditions}
                  >
                    {group.userAttributes.length}
                  </BoxTableCell>
                </BoxTableRow>
              ))}
            </BoxTable>
          ) : (
            <EmptyIndicator
              icon="users"
              title={messages.groupsEmpty}
              description={messages.groupsEmptyDescription}
            />
          )}
        </Box>

        <style jsx>{`
          .title {
            color: ${theme.textColorLight};
            font-weight: 700;
          }
          .owners {
            color: ${theme.textColorLighter};
            display: inline-block;
            font-size: 1.3rem;
            font-weight: 600;
          }
          .empty {
            color: ${theme.textColorLighter};
            font-size: 1.6rem;
            margin: 50px 0;
            text-align: center;
          }
        `}</style>
      </div>
    );
  }
);

export default GroupsList;
